export default [
    {
      path: "/games/miniGames",
      name: "games.miniGames",
      meta: {
        title: "小游戏",
      },
      component: () => import("./MiniGames"),
    },
    {
      path: '/games/new',
      name: 'games.new',
      meta: {
        title: '新游推荐'
      },
      component: () => import('./NewGames')
    }
  ];